import React, { useState, useEffect } from 'react'
import { RestApi } from '../../../RestApi'
import GLOBAL from '../../../Globals'
import { Table, Button, Tag, Tooltip } from 'antd'

function UserMCQs(props) {
    const userId = props.userId

    const [stats, setStats] = useState({})
    const [activity, setActivity] = useState([])
    const [activityNextUrl, setActivityNextUrl] = useState()
    const [subjectCompletion, setSubjectCompletion] = useState([])

    const [loadingStats, setLoadingStats] = useState(false)
    const [loadingActivity, setLoadingActivity] = useState(false)
    const [loadingSubjectCompletion, setLoadingSubjectCompletion] =
        useState(false)

    useEffect(() => {
        getStats()
        getActivity()
        getSubjectCompletion()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getStats = () => {
        setLoadingStats(true)

        RestApi.doGet(GLOBAL.URL.MCQ.GET_USER_STATS + userId)
            .then((res) => {
                setStats(res.data)
            })
            .finally(() => {
                setLoadingStats(false)
            })
    }

    const getActivity = () => {
        setLoadingActivity(true)

        RestApi.doGet(GLOBAL.URL.MCQ.GET_USER_ACTIVITY + userId)
            .then((response) => {
                var res = JSON.parse(response.data)
                setActivity(res.data)
                setActivityNextUrl(res.next)
            })
            .finally(() => {
                setLoadingActivity(false)
            })
    }

    const getSubjectCompletion = () => {
        setLoadingSubjectCompletion(true)

        RestApi.doGet(GLOBAL.URL.MCQ.GET_USER_SUBJECT_COMPLETION + userId)
            .then((res) => {
                setSubjectCompletion(res.data)
            })
            .finally(() => {
                setLoadingSubjectCompletion(false)
            })
    }

    const subjectCompletionColumns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 50,
            render: (text, record, index) => <span>{index + 1}</span>,
        },
        {
            title: 'Subject Name',
            dataIndex: 'subjectName',
            key: 'subjectName',
        },
        {
            title: 'Chapter Tests',
            dataIndex: 'chapterTests',
            key: 'chapterTests',
            render: (text, record) => (
                <span>
                    {record.chapterTestsCompleted + ' / ' + record.chapterTests}
                </span>
            ),
        },
        {
            title: 'Comprehensive Tests',
            dataIndex: 'compTests',
            key: 'compTests',
            render: (text, record) => (
                <span>
                    {record.comprehensiveTestsCompleted +
                        ' / ' +
                        record.comprehensiveTests}
                </span>
            ),
        },
    ]

    const getMoreActivity = () => {
        if (!activityNextUrl) {
            return
        }

        setLoadingActivity(true)

        RestApi.doGet(GLOBAL.URL.BASE_URL + activityNextUrl)
            .then((response) => {
                var res = JSON.parse(response.data)
                setActivity((preState) => {
                    return [...preState, ...res.data]
                })
                setActivityNextUrl(res.next)
            })
            .finally(() => {
                setLoadingActivity(false)
            })
    }

    const activityColumns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 50,
            render: (text, record, index) => <span>{index + 1}</span>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => (
                <>
                    <Tag
                        color={
                            record.status === 'completed' ? 'green' : 'geekblue'
                        }
                    >
                        {record.status}
                    </Tag>
                    <br />
                    <span style={{ fontSize: 11 }}>
                        {'Attempt - ' + record.attempt}
                    </span>
                </>
            ),
        },
        {
            title: 'Subject',
            dataIndex: 'subject',
            key: 'subject',
            render: (text, record) => (
                <span>
                    <b>{record.subject}</b>
                    <br />
                    <span style={{ fontSize: 11 }}>
                        &emsp;
                        {'Test - ' + record.testName}
                    </span>
                </span>
            ),
        },
        {
            title: 'Chapter Test',
            dataIndex: 'chapterTest',
            key: 'chapterTest',
            render: (text, record) => (
                <span>
                    {record.chapterTest ? (
                        <Tooltip title={record.chapter}>{'Yes'}</Tooltip>
                    ) : (
                        ''
                    )}
                </span>
            ),
        },
        {
            title: 'Questions',
            dataIndex: 'totalQuestions',
            key: 'totalQuestions',
        },
        {
            title: 'Correct',
            dataIndex: 'correctAnswers',
            key: 'correctAnswers',
        },
        {
            title: 'Wrong',
            dataIndex: 'wrongAnswers',
            key: 'wrongAnswers',
        },
        {
            title: 'Unanswered',
            dataIndex: 'unanswered',
            key: 'unanswered',
        },
        {
            title: 'Points',
            dataIndex: 'points',
            key: 'points',
            render: (text, record) => (
                <span style={{ fontSize: 11 }}>
                    {record.pointsEarned + ' / ' + record.totalPoints}
                </span>
            ),
        },
        {
            title: 'Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text, record) => (
                <span style={{ fontSize: 11 }}>
                    {record.createdAt}
                    <br />
                    {record.updatedAt}
                </span>
            ),
        },
    ]

    return (
        <div>
            {!loadingStats ? (
                <div>
                    <Tag color="geekblue">
                        Total Questions: {stats.questions}
                    </Tag>
                    <Tag color="purple" style={{ marginLeft: 10 }}>
                        Total Tests: {stats.tests}
                    </Tag>
                    <Tag color="purple" style={{ marginLeft: 10 }}>
                        Test In Progress: {stats.testsStarted}
                    </Tag>
                    <Tag color="purple" style={{ marginLeft: 10 }}>
                        Test Completed: {stats.testsCompleted}
                    </Tag>
                </div>
            ) : null}
            <div>
                <h3>Subject Completion Status</h3>
                <Table
                    loading={loadingSubjectCompletion}
                    columns={subjectCompletionColumns}
                    dataSource={subjectCompletion}
                    pagination={false}
                    size="small"
                    rowKey="subjectName"
                />
            </div>
            <div style={{ marginTop: 5 }}>
                <h3>Test Activity</h3>
                <Table
                    loading={loadingActivity}
                    columns={activityColumns}
                    dataSource={activity}
                    pagination={false}
                    size="small"
                    rowKey="subjectName"
                />
                {activityNextUrl ? (
                    <Button
                        type="primary"
                        onClick={getMoreActivity}
                        style={{ marginTop: 10 }}
                        loading={loadingActivity}
                        size="small"
                    >
                        Show More
                    </Button>
                ) : null}
            </div>
        </div>
    )
}

export default UserMCQs
